module.exports = ($scope, $uibModalInstance, mappings) ->
  $scope.file = null
  $scope.supportedExtensions = ['csv']
  $scope.invalidFileExtension = false

  $scope.mappings = mappings?.results
  $scope.selected =
    mapping: $scope.mappings?[0]

  $scope.shouldShowMappingSelector = ->
    $scope.selected?.mapping?

  $scope.setFile = (files) ->
    if files.length > 0
      $scope.file = files[0]
    $scope.setInvalidFileExtension()

  $scope.setInvalidFileExtension = () ->
    if not $scope.file? or not $scope.file.name?
      return $scope.invalidFileExtension = false
    fileNameArray = $scope.file.name.split('.')
    fileExtension = fileNameArray[fileNameArray.length - 1].toLowerCase()
    $scope.invalidFileExtension = fileExtension not in $scope.supportedExtensions

  $scope.upload = () ->
    $uibModalInstance.close({
      file: $scope.file,
      mappingId: $scope.selected?.mapping?.id
      mappingName: $scope.selected?.mapping?.name
    })

  $scope.cancel = ->
    $uibModalInstance.close()
    return

  $scope.canUpload = ->
    !$scope.invalidFileExtension && $scope.file
